"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class CommissionModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            agentAccess: 'McLabs2__Agent_Access__c',
            agentPercentage: 'McLabs2__Agent_Percentage__c',
            compId: 'McLabs2__Sale__c',
            contractId: 'McLabs2__Escrow__c',
            externalAgentId: 'McLabs2__Broker_Contact__c',
            internalAgentId: 'McLabs2__Broker__c',
            listingId: 'McLabs2__Listing__c',
            ownerId: 'OwnerId',
            pursuitId: 'McLabs2__Proposal__c',
            role: 'McLabs2__Role__c',
            stage: 'McLabs2__Stage__c',
            status: 'McLabs2__Status__c'
        };
    }
}
CommissionModel.ACCESSES = {
    READ_ONLY: 'Read Only',
    READ_EDIT: 'Read & Edit'
};
CommissionModel.ROLES = {
    BUYER_REP: 'Buyer Rep',
    SELLER_REP: 'Seller Rep',
    TENANT_REP: 'Tenant Rep',
    LANDLORD_REP: 'Landlord Rep',
    MANAGER: 'Manager'
};
exports.CommissionModel = CommissionModel;
//# sourceMappingURL=commission.model.js.map